"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    SnapshotPanel: ()=>SnapshotPanel
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
function SnapshotPanel(props) {
    const { component, additionalProps, ...rest } = props;
    const Component = component;
    const id = (0, external_react_namespaceObject.useId)();
    const additionalPropName = Object.keys(additionalProps ?? {})[0];
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("h1", {
                className: "mb-2 mt-6 text-2xl font-bold",
                children: [
                    rest.propName,
                    " ",
                    additionalPropName ? ' + ' + additionalPropName : null
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: "flex flex-row gap-5",
                children: Object.entries(rest.props ?? {}).map(([key, value])=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                        className: "flex flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("h2", {
                                className: "propValue",
                                children: String(value[rest.propName])
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Component, {
                                    ...value,
                                    ...additionalProps
                                })
                            })
                        ]
                    }, `SnapshotPanel-${key}-${id}`))
            })
        ]
    });
}
exports.SnapshotPanel = __webpack_exports__.SnapshotPanel;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "SnapshotPanel"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
